<header *ngIf="seo" #headerRef>
  <div class="content">
    <h1 class="display">{{ seo?.title }}</h1>
    <p class="heading">{{ seo?.description }}</p>
  </div>
  <img
    class="image"
    [src]="
      seo
        | seoImageUrl
          : {
              text: false,
              format: 'rectangle',
              logo: false,
              category: category
            }
    "
    [alt]="seo?.title"
    [title]="seo?.title"
  />
</header>
